module.exports = __webpack_public_path__ + "img/Cat.638abfa4.jpg";